import axios from 'axios'
import auth from '../users/auth'
import logoutOnUnauthorized from "../logout";
const ENDPOINT_FAQ = auth.api.endpointPath + 'faqs'
const ENDPOINT_SUPPORT_TICKET = auth.api.endpointPath + 'support_tickets'
const faqList = {}
export default {
  getFaqs () {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.get(ENDPOINT_FAQ).catch(logoutOnUnauthorized)
  },
  getFaqById (id) {
    if (faqList !== null) {
      return this.faqList.find((faq) => faq.id === id)
    } else {
      const token = sessionStorage.getItem('token')
      axios.defaults.headers.common.Authorization = 'Bearer ' + token
      axios.get(ENDPOINT_FAQ)
        .then(response => {
          this.faqList = response.data['hydra:member']
          return response.data['hydra:member'].find((faq) => faq.id === id)
        }).catch(logoutOnUnauthorized)
    }
  },
  postFaq (faq) {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.post(ENDPOINT_FAQ, faq).catch(logoutOnUnauthorized)
  },
  putFaq (faq) {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.put(ENDPOINT_FAQ + '/' + faq.id, faq).catch(logoutOnUnauthorized)
  },
  deleteFaq (faq) {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.delete(ENDPOINT_FAQ + '/' + faq.id).catch(logoutOnUnauthorized)
  },
  sendTicket(data){
      const token = sessionStorage.getItem('token')
      axios.defaults.headers.common.Authorization = 'Bearer ' + token
      return axios.post(ENDPOINT_SUPPORT_TICKET,data).catch(logoutOnUnauthorized)
  }
}
